module.exports = __webpack_public_path__ + "img/audioMic.0c04098c.svg";